import { DemoExample } from "@/components/sections/DemoSection";

export const vintageEffectDemo: DemoExample = {
    label: "Vintage Effects",
    beforeImage: "/images/demos/vintage/vintage-before.webp",
    beforeImageSrcSet: "/images/demos/vintage/vintage-before-400w.webp 400w, /images/demos/vintage/vintage-before-800w.webp 800w",
    afterImage: "/images/demos/vintage/vintage-after.webp",
    afterImageSrcSet: "/images/demos/vintage/vintage-after-400w.webp 400w, /images/demos/vintage/vintage-after-800w.webp 800w",
    title: "Vintage Photo Effects",
    description: "Transform modern photos with authentic vintage effects, sepia tones, and classic B&W filters.",
    alt: "Before and after vintage effect application"
};

export const styleFilterDemo: DemoExample = {
    label: "Style Filter",
    beforeImage: "/images/demos/style-filter/style-filter-before.webp",
    beforeImageSrcSet: "/images/demos/style-filter/style-filter-before-400w.webp 400w, /images/demos/style-filter/style-filter-before-800w.webp 800w",
    afterImage: "/images/demos/style-filter/style-filter-after.webp",
    afterImageSrcSet: "/images/demos/style-filter/style-filter-after-400w.webp 400w, /images/demos/style-filter/style-filter-after-800w.webp 800w",
    title: "Artistic Style Transfer",
    description: "Transform your photos into paintings, sketches, and artistic masterpieces.",
    alt: "Before and after artistic style transfer"
};

export const specializedEditingDemo: DemoExample = {
    label: "Specialized Editing",
    beforeImage: "/images/demos/specialized/specialized-before.webp",
    beforeImageSrcSet: "/images/demos/specialized/specialized-before-400w.webp 400w, /images/demos/specialized/specialized-before-800w.webp 800w",
    afterImage: "/images/demos/specialized/specialized-after.webp",
    afterImageSrcSet: "/images/demos/specialized/specialized-after-400w.webp 400w, /images/demos/specialized/specialized-after-800w.webp 800w",
    title: "Photo to Illustration",
    description: "Convert photos into custom illustrations and vector art.",
    alt: "Before and after photo to illustration conversion"
};
